/**
 * Die Kennung der laufenden (oder jüngsten) Aufnahme — Welle 0 des Jev-Optimierungsplans (shared/jev-messung.ts).
 * NUR MESSEN: die Kennung ist eine Zufalls-ID ohne Inhalt; sie ändert kein Verhalten.
 *
 * Die App erzeugt sie, wenn eine Aufnahme beginnt (`beginneAufnahme`), und hängt sie in die Jev-Zeilen der beiden Ausgänge
 * (meldeDiagnose in app.ts, meldeSpur in lib/mikro-spur.ts: `mitAufnahmeKennung`). An den Server geht sie mit dem Nachhören
 * (Abfrage `aufnahme`), mit `/api/stille-auto` und mit dem Upload (Feld `az`).
 */
import { istJevZeile, mitMessung, neueAufnahmeKennung } from "../../shared/jev-messung.js";

let aktuell: string | null = null;

/** Eine Aufnahme beginnt: neue Kennung. */
export function beginneAufnahme(): string {
  aktuell = neueAufnahmeKennung();
  return aktuell;
}

/** Die Kennung der laufenden oder jüngsten Aufnahme; `null`, wenn noch keine begann. */
export function aufnahmeKennung(): string | null {
  return aktuell;
}

/**
 * Setzt `az=` und `regelv=` in eine Jev-Zeile (andere Zeilen bleiben unverändert). `az`: die Kennung, die zur Zeile gehört;
 * ohne Angabe (undefined) die der laufenden Aufnahme, `null` = keine (`az=-`). Immer an — den Notschalter `JEV_MESSUNG=0` wertet der Server aus (messzeile-route.ts).
 */
export function mitAufnahmeKennung(zeile: string, az?: string | null): string {
  // Ausdrücklich `null` (getippter Zug, keine Aufnahme dahinter): `az=-` — nie die Kennung der letzten Sprachaufnahme borgen.
  // Ohne Angabe und ohne je begonnene Aufnahme bleibt die Zeile, wie sie war.
  if (!istJevZeile(zeile) || (az === undefined && aktuell === null)) return zeile;
  return mitMessung(zeile, az === undefined ? aktuell : az, true);
}
